import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export default class FastPhonicsQuickLinksRoute extends Route {
  @service contentfulClient!: ContentfulClientService

  async model() {
    const { researchReports, teacherGuides, curriculumMaps, certificates } =
      await this.contentfulClient.getFastPhonicsEntries({
        role: 'teacher',
      })

    return { researchReports, teacherGuides, curriculumMaps, certificates }
  }
}
